
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hKeSi", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $gGHFp = parcelRequire("gGHFp");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $e4o8D = parcelRequire("e4o8D");


var $6gj4X = parcelRequire("6gj4X");

const $a9b8ba98dfcca4d1$export$5a0ddb4204896541 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { contentId: contentId, contentType: contentType, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, annotationProvider: annotationProvider } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const isHidden = Boolean(node?.parameters?.macroParams?.hidden?.value);
    let t1;
    if ($[0] !== node) {
        t1 = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const attributes = t1;
    const document = {
        type: "doc",
        version: 1,
        content: node?.content
    };
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const { mode: contentMode } = (0, $gGHFp.useEditorContentModeValue)(t2);
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    let t3;
    if ($[4] !== node) {
        t3 = (0, $6gj4X.getMacroId)(node);
        $[4] = node;
        $[5] = t3;
    } else t3 = $[5];
    const macroId = t3;
    const t4 = "page-properties-macro";
    let t5;
    if ($[6] !== macroId || $[7] !== renderServerPlaceholder) {
        t5 = renderServerPlaceholder ? {
            "data-ssr-placeholder": macroId
        } : {
            "data-ssr-placeholder-replace": macroId
        };
        $[6] = macroId;
        $[7] = renderServerPlaceholder;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            contentType: contentType,
            document: document
        }),
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        extensionHandlers: extensionHandlers,
        appearance: appearance || "default",
        contentMode: contentMode,
        spaceKey: spaceKey,
        UNSTABLE_allowTableResizing: false,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider,
        ...(0, $iu6m9.editorExperiment)("comment_on_bodied_extensions", true) ? {
            allowInlineComments: true
        } : {}
    });
    let t7;
    if ($[9] !== mode || $[10] !== node) {
        t7 = (0, $5kjCz.getExperienceName)(mode, node);
        $[9] = mode;
        $[10] = node;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== attributes || $[13] !== contentId || $[14] !== extensionKey || $[15] !== mode || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: t7,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            contentId: contentId
        });
        $[12] = attributes;
        $[13] = contentId;
        $[14] = extensionKey;
        $[15] = mode;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== macroId || $[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-fabric-macro": macroId,
            "data-vc": t4,
            ...t5
        }, t6, t8);
        $[18] = macroId;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["DetailsExtensionHandler"] = $a9b8ba98dfcca4d1$export$5a0ddb4204896541;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage);
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !contentId // avoid starting network flow
        ,
        __callerPackage__: "@confluence/editor-content-mode-button"
    });
    let serverModeRaw;
    const contentProps = data?.content?.nodes?.[0]?.contentProperties;
    if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
    else serverModeRaw = contentProps?.latest?.contentMode;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: Boolean(loading),
            error: error ?? null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("6gj4X", function(module, exports) {
const $45b144f792a5212a$export$36b5af56b86b89d3 = (isLegacyRenderer, rendererProps)=>{
    if (!isLegacyRenderer) return rendererProps;
    return {
        adf: rendererProps.document,
        objectId: rendererProps.contentId,
        contentType: rendererProps.contentType
    };
};
const $45b144f792a5212a$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;
module.exports["convertRendererProps"] = $45b144f792a5212a$export$36b5af56b86b89d3;
module.exports["getMacroId"] = $45b144f792a5212a$export$47eae2202f029f6b;

});


//# sourceMappingURL=DetailsExtensionHandler.505da12c.js.map
